import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Card, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { eliminarFeriado, feriadosSeleccionar } from '../../../../actions/turnos/feriados';
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { FERIADOS_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';

const style = {
    root:
    {
        width:700,
        margin:30,
        padding:20
    },
    table: {
        padding: 0, 
        margin:0, 
        boxSizing: "border-box"
    },
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop:0,
        marginBottom:0
    }
};

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatFecha = fecha => {
    return new Date(fecha).toLocaleString(
        "es",
        optionsfecha
    );
}

export const ListaFeriados = (props) => {
    const dispatch = useDispatch();
    const { items, cargada } = props;
    const [ selected, setSelected ] = useState();
    const [ openQuestion, setOpenQuestion ] = useState(false);

    const handleEditItem = item => {
        dispatch( feriadosSeleccionar(item) );
    }

    const handleOpenQuestion = (item) => {
        setSelected(item);
        setOpenQuestion(true);
    }

    const handleClose = () => {
        resetValues();
    }

    const deleteFeriado = () => {
        dispatch( eliminarFeriado(selected.idFeriado) );
        resetValues();
    }

    const resetValues = () => {
        setOpenQuestion(false);
        setSelected();
    }

    return (
        <>
            {cargada&&
                <Card className={style.root}>  
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Fecha</TableCell>
                                    <TableCell align="left">Descripcion</TableCell>
                                    <TableCell align="left">Tipo</TableCell>
                                    <TableCell align="left">Centros Medicos</TableCell>
                                    <TableCell align="left"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                        items
                                            .slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage)
                                            .map((item) => {

                                                return (
                                                    <TableRow key={item.idFeriado}>
                                                        <TableCell align="left">
                                                            <IconButton style={{ padding: 0, margin:0 }}
                                                                color="primary"
                                                                aria-label="Editar"
                                                                onClick={(e) => handleEditItem(item)}
                                                                disabled={!validarSoloUnPermiso(props.permisosUser, FERIADOS_PERMISOS.MODIFICACION)}
                                                            >
                                                                <EditIcon style={style.iconButton} />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {new Date(item.feriado).toLocaleString(
                                                                "es",
                                                                optionsfecha
                                                            )}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.descripcionFeriado}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.tipoFeriado.descripcionFeriado}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.idTipoFeriado === 1
                                                                ?
                                                                    'TODOS'
                                                                :
                                                                    item.feriadosCentros.filter(s => !s.idUsuarioBaja).map((centro) => 
                                                                        `${centro.centroMedico.descripcionCentro} - `
                                                                    )
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton 
                                                                style={{ padding: 0, margin: 0 }}
                                                                onClick={(e) => handleOpenQuestion(item)}
                                                                disabled={!validarSoloUnPermiso(props.permisosUser, FERIADOS_PERMISOS.BAJA)}
                                                                color="primary"
                                                                aria-label="seleccionar"
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                            )
                                        })
                                    :
                                        <TableRow style={{ height: 50 }}>
                                            <TableCell colSpan={8} style={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {openQuestion && 
                        <AlertFinalizadoStepper
                            open={openQuestion}
                            pregunta={"Eliminar Feriado"}
                            dialogText={`Se va a eliminar el feriado ${selected.descripcionFeriado} del ${formatFecha(selected.feriado)}, está seguro?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            handleClose={handleClose}
                            handleSend={deleteFeriado}
                        />
                    }  
                </Card>
            }  
        </>
     );
}